import { buildEpisodes } from "@/utils/video";

interface EpisodeListProps {
  total: number;
  current: number;
  onSelect: (index: number) => void;
}

export default function EpisodeList({ total, current, onSelect }: EpisodeListProps) {
  const episodes = buildEpisodes(total);

  return (
    <section className="mt-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2">
          <i className="ri-list-check-2 text-accent-500" /> 剧集列表
        </h2>
        <span className="text-sm text-foreground-500">共 {total} 集</span>
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-2 md:gap-3">
        {episodes.map((ep) => (
          <button
            key={ep.index}
            type="button"
            title={`${ep.title} · ${ep.duration}`}
            onClick={() => onSelect(ep.index)}
            className={`py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
              current === ep.index
                ? "bg-accent-500 text-background-50 font-semibold"
                : "bg-background-200/60 text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
            }`}
          >
            {ep.index}
          </button>
        ))}
      </div>
    </section>
  );
}